/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class MapIterator<S, T> implements IterableIterator<T> {

  private index: number = -1;

  constructor(
    private sourceIterator: Iterator<S>,
    private mapper: (value: S, index: number) => T
  ) { }

  next(): IteratorResult<T> {
    const sourceEntryResult = this.sourceIterator.next();
    if (sourceEntryResult.done) {
      return { done: true, value: undefined };
    }
    this.index++;
    const sourceValue: S = sourceEntryResult.value;
    const targetValue: T = this.mapper(sourceValue, this.index);
    return { done: false, value: targetValue };
  }

  [Symbol.iterator](): IterableIterator<T> {
    return this;
  }
}
